import * as React from "react";
const SvgLeftChevronIcon = (props) => /* @__PURE__ */ React.createElement("svg", { id: "a", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", ...props }, /* @__PURE__ */ React.createElement("polygon", { points: "18.27 50.16 68.11 100 81.38 86.73 44.66 50.02 81.38 13.3 68.11 .03 18.27 49.87 18.41 50.02 18.27 50.16" }));
export default SvgLeftChevronIcon;
